import { Typography } from '@mui/material';
import React from 'react';

import HeaderWithActions from '../../../../../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../../../../../lib/designSystem/Table';

const headers: { key: string; label: string; type?: any }[] = [
  { key: 'folio', label: 'Id', type: 'numeric-id' },
  { key: 'category', label: 'Categoría' },
  { key: 'observation', label: 'Observación' },
  { key: 'businessName', label: 'Cliente' },
  { key: 'issuedDate', label: 'Fecha', type: 'date' },
  { key: 'totalAmount', label: 'Monto total', type: 'money' },
  { key: 'amount', label: 'Monto descontado', type: 'money' },
];

const PayOutDetaiPendingAccounts = (props: any) => {
  const { pendingAccounts } = props;

  return (
    <div>
      <HeaderWithActions
        title="Acá puedes ver los pagos realizados."
        variant="body1"
      />
      {pendingAccounts.length === 0 ? (
        <Typography variant="body1">
          No hay cuentas pendientes en este pago
        </Typography>
      ) : (
        <EnhancedTable
          dataHeaders={headers}
          data={pendingAccounts}
          finalSumRow
        />
      )}
    </div>
  );
};

export default PayOutDetaiPendingAccounts;
